import React from 'react';
import {useCheckIfAdmin} from "../firebase/useCheckIfAdmin";
import {InstructorsTable} from "./InstructorsTable";
import Paper from "@mui/material/Paper";
import {UnauthorizedAccess} from "../app/UnauthorizedAccess";

export const Admin = () => {
    const isAdmin = useCheckIfAdmin();

    if (!isAdmin) {
        return <UnauthorizedAccess requiredRole="administrator" />;
    }

    return (
        <div>

            <Paper
                sx={{
                    p: {
                        xs: 1,
                        md: 4
                    },
                    mb: 4
                }}
            >
                <InstructorsTable />
            </Paper>
        </div>
    )
}